export default __webpack_public_path__ + "static/media/main-visual.13f0f82b.png";